import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3106, { U3106ROLES } from "./U3106";
import U3106ExpenseTypeList from "./components/U3106ExpenseTypeList";
import U3106ExpenseTypeForm from "./components/U3106ExpenseTypeForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3106Routes: RouteObject[] = [
  {
    path: "U3106",
    element: <U2000RequireRole allowedRoles={[U3106ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3106 />,
        children: [
          { index: true, element: <U3106ExpenseTypeList /> },
          { path: ":id", element: <U3106ExpenseTypeForm /> },
        ],
      },
    ],
  },
];

export default U3106Routes;
